// 소리 on/off '선호값'만 담당(Howler 비의존) — 랜딩·설정 등 가벼운 화면이 여기서 읽고 쓴다.
// 실제 재생(Howl 로딩·앰비언스)은 world/sound.ts 가 이 값을 읽어 수행. 자동재생 금지(불변식 6): 기본 꺼짐.
const PREF_KEY = "gc_sound_v1";

export function getSoundPref(): boolean {
  try {
    return localStorage.getItem(PREF_KEY) === "1";
  } catch {
    return false;
  }
}

export function setSoundPref(on: boolean): void {
  try {
    localStorage.setItem(PREF_KEY, on ? "1" : "0");
  } catch {
    /* 프라이빗 모드 등 — 저장 실패해도 동작엔 지장 없음 */
  }
}
